var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0312 25.8125C35.0312 24.3455 34.4485 22.9386 33.4112 21.9013C32.3739 20.864 30.967 20.2812 29.5 20.2812C28.033 20.2812 26.6261 20.864 25.5888 21.9013C24.5515 22.9386 23.9688 24.3455 23.9688 25.8125C23.9688 27.2795 24.5515 28.6864 25.5888 29.7237C26.6261 30.761 28.033 31.3438 29.5 31.3438C30.967 31.3438 32.3739 30.761 33.4112 29.7237C34.4485 28.6864 35.0312 27.2795 35.0312 25.8125ZM51.625 25.8125C51.625 36.4104 40.2048 47.9965 33.7738 53.6826C32.5979 54.7327 31.0765 55.3132 29.5 55.3132C27.9235 55.3132 26.4021 54.7327 25.2262 53.6826C18.7952 47.9965 7.375 36.4104 7.375 25.8125C7.375 22.907 7.94728 20.03 9.05917 17.3456C10.1711 14.6613 11.8008 12.2223 13.8553 10.1678C15.9098 8.11327 18.3488 6.48355 21.0331 5.37167C23.7175 4.25978 26.5945 3.6875 29.5 3.6875C32.4055 3.6875 35.2825 4.25978 37.9669 5.37167C40.6512 6.48355 43.0902 8.11327 45.1447 10.1678C47.1992 12.2223 48.8289 14.6613 49.9408 17.3456C51.0527 20.03 51.625 22.907 51.625 25.8125ZM47.9375 25.8125C47.9375 20.9226 45.995 16.2329 42.5373 12.7752C39.0796 9.31752 34.3899 7.375 29.5 7.375C24.6101 7.375 19.9204 9.31752 16.4627 12.7752C13.005 16.2329 11.0625 20.9226 11.0625 25.8125C11.0625 29.8983 13.3303 34.6441 16.8519 39.3936C20.296 44.0324 24.5477 48.1587 27.6673 50.9207C28.1693 51.3757 28.8225 51.6277 29.5 51.6277C30.1775 51.6277 30.8307 51.3757 31.3327 50.9207C34.4523 48.1587 38.7077 44.0361 42.1481 39.3936C45.6697 34.6441 47.9375 29.8983 47.9375 25.8125Z",
    fill: "url(#paint0_linear_1228_10607)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1228_10607",
    x1: 14.6151,
    y1: -8.91748,
    x2: -13.9388,
    y2: 72.3169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF46AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDF37A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocal);
export default __webpack_public_path__ + "static/media/local.08eccefb1a68e5b5d21a858cc260bdf7.svg";
export { ForwardRef as ReactComponent };